"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Timeline.css");

var _Paragraph = _interopRequireDefault(require("../../Typography/Paragraph/Paragraph"));

var _Heading = _interopRequireDefault(require("../../Typography/Heading/Heading"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @visibleName Timeline
 */
function Timeline(_ref) {
  var data = _ref.data,
      margin = _ref.margin,
      header = _ref.header,
      footer = _ref.footer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-main-container",
    style: {
      margin: margin
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-header"
  }, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    level: "4"
  }, header)), /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-list"
  }, data.length !== 0 ? data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "timeline-item-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline-item-color"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        backgroundColor: item.color != null ? Timeline.colors[item.color][0] : Timeline.colors[green][0]
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: item.direction == 'out' ? 'arrowUpRight' : 'downLeft',
      color: item.color != null ? Timeline.colors[item.color][1] : Timeline.colors[green][1]
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "timeline-item"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      fontSize: "14B"
    }, item.heading)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      fontSize: "14"
    }, item.address), /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
      fontSize: "14"
    }, item.details))));
  }) : ''), !!footer && /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline-footer"
  }, footer));
}

Timeline.propTypes = {
  /** List header */
  header: _propTypes.default.string,

  /** List footer */
  footer: _propTypes.default.any,

  /** List margins */
  margin: _propTypes.default.string,

  /** Elements to be rendered as list items */
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Item heading */
    heading: _propTypes.default.any,

    /** Item addresses */
    address: _propTypes.default.string,

    /** Item details */
    details: _propTypes.default.string,

    /** Item status color */
    color: _propTypes.default.oneOf(['blue', 'grey', 'red', 'green', 'orange']),

    /** Item direction */
    direction: _propTypes.default.oneOf(['in', 'out'])
  }).isRequired)
};
Timeline.defaultProps = {
  margin: '0'
};
Timeline.colors = {
  blue: ['rgba(47, 97, 224, 0.2)', _Colors.default.sinineVaal],
  grey: ['rgba(168, 173, 180, 0.2)', _Colors.default.vagaVesi],
  red: ['rgba(224, 30, 90, 0.2)', _Colors.default.hapumarjapuu],
  green: ['rgba(54, 179, 126, 0.2)', _Colors.default.maismaa],
  orange: ['rgba(239, 127, 87, 0.2)', _Colors.default.loojang]
};
var _default = Timeline;
exports.default = _default;